var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dialogs),function(item){return _c(item.name,{key:item.id,tag:"component",attrs:{"assigned-id":item.id,"params":item.params}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }